import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight, FaPlus, FaMinus } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { addToWishlist, removeFromWishlist } from "../../../utils/wishlistUtils";
import { FaClock } from "react-icons/fa";
import { MdElectricBolt } from "react-icons/md";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";
import "swiper/css";
import "swiper/css/navigation";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { addToCart, removeFromCart, editCartProduct, } from "../../../utils/cartUtils";


const Product6 = ({ data }) => {
  const [showLoginMsg, setShowLoginMsg] = useState({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [themeColor, setThemeColor] = useState("#ffffff");
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef1 = useRef(null);
  const navigate = useNavigate();
  const [showQty, setShowQty] = useState({});
  const [cartData, setCartData] = useState([]);

  const fetchCartList = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_list`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
          pincode: sessionStorage.getItem("userPincode"),
          user_auto_id: sessionStorage.getItem("accessToken"),
          page_number: 1,
          limit: 10

        }
      );

      if (response.data.status === 1) {
        setCartData(response.data.get_admin_cart_product_lists); // your response name may differ
      }
    } catch (error) {
      console.error("Fetch cart failed", error);
    }
  };



  const isLoggedIn = () => {
    return !!sessionStorage.getItem("accessToken");
  };



  // quick view states
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSizes, setSelectedSizes] = useState({});

  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedSizePrice, setSelectedSizePrice] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState({});
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const handleCardClick = (productId) => {
    navigate(`/product-detail/${productId}`);
  };
  const [wishlisted, setWishlisted] = useState({});

  const [isVibrating, setIsVibrating] = useState(false);        // Vibration effect
  const [wishlistMessage, setWishlistMessage] = useState({ text: "", type: "" });  // Message


  const clearMessage = (productId) => {
    setTimeout(() => {
      setMessage((prev) => ({
        ...prev,
        [productId]: null,
      }));
    }, 2000);
  };


  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;
    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));
    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    fetchCartList();
  }, []);

  useEffect(() => {
    if (!cartData.length || !products.length) return;

    const updatedSizes = {};

    cartData.forEach((cartItem) => {
      const product = products.find(
        (p) => p.id === cartItem.product_auto_id
      );

      if (!product || !product.size?.length) return;

      // 🔁 convert size_auto_id → index
      const sizeIndex = product.size.findIndex(
        (s) => s.size_auto_id === cartItem.user_seleted_size
      );

      if (sizeIndex === -1) return;

      const sizeObj = product.size[sizeIndex];
      const priceObj = product.get_price_lists?.[sizeIndex];

      updatedSizes[product.id] = {
        sizeIndex,
        sizeId: sizeObj.size_auto_id,
        sizeName: sizeObj.size_name,
        price: Number(priceObj?.final_size_price || product.price),
        stock: Number(sizeObj.size_stock),
      };
    });

    setSelectedSizes((prev) => ({
      ...prev,
      ...updatedSizes,
    }));
  }, [cartData, products]);


  // fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_new_product_list`,
          {
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Products",
            limit: 6,
            page_number: 1,
            customer_auto_id: accessToken || adminId,
          }
        );

        if (response.data.status === 1 && Array.isArray(response.data.get_products_lists)) {
          const formatted = response.data.get_products_lists.map((p) => ({
            id: p.product_auto_id,
            name: p.product_name,
            description: p.description,
            price: Number(p.final_product_price),
            originalPrice: p.product_price
              ? Number(p.product_price)
              : null,

            discount: p.offer_percentage ? `${p.offer_percentage}% off` : undefined,
            delivery:
              p.time && p.time_unit
                ? `Delivery in ${p.time} ${p.time_unit}`
                : "Delivery time unavailable",
            images: p.product_images
              ? p.product_images.map(
                (img) =>
                  `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
              )
              : [],
            size: p.size || [],
            get_price_lists: p.get_price_lists || [],
            moq: p.moq || 1,
            user_auto_id: p.user_auto_id,
          }));
          setProducts(formatted);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [data._id]);

  const handleWishlistToggle = async (e, product) => {
    e.preventDefault();

    if (!isLoggedIn()) {
      setWishlistMessage({ text: "Please login", type: "error" });
      return;
    }

    const productId = product.id;

    try {
      if (wishlisted[productId]) {
        const res = await removeFromWishlist(productId);
        if (res?.status === 1) {
          setWishlisted((prev) => ({
            ...prev,
            [productId]: false,
          }));
        }
      } else {
        const res = await addToWishlist(productId);
        if (res?.status === 1) {
          setWishlisted((prev) => ({
            ...prev,
            [productId]: true,
          }));
        }
      }
    } catch (err) {
      console.error("Wishlist error", err);
    }
  };



  useEffect(() => {
    const loadWishlist = async () => {
      if (!isLoggedIn()) return;

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_wishlist`,
          {
            customer_auto_id: sessionStorage.getItem("accessToken"),
          }
        );

        if (res.data.status === 1) {
          const map = {};
          res.data.wishlist.forEach((item) => {
            map[item.product_auto_id] = true;
          });
          setWishlisted(map);
        }
      } catch (err) {
        console.error("Wishlist load failed", err);
      }
    };

    loadWishlist();
  }, []);


  // Theme
  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      setThemeColor(JSON.parse(storedStyle).web_theme_colour);
    }
  }, []);

  const getCartItem = (productId) =>
    cartData.find((item) => item.product_auto_id === productId);

  if (loading || products.length === 0) return null;

  return (
    <div
      className="relative p-4 product1-component"
      style={{ backgroundColor: data.web_background_color }}
    >
      <div className="mb-4">
        <h1
          className={`text-2xl font-bold ${data.web_title_font} text-${data.title_alignment}`}
          style={{ color: data.web_title_color }}
        >
          {data.title}

        </h1>
      </div>

      {/* Swiper */}
      <Swiper
        ref={swiperRef1}
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        navigation={{
          nextEl: `.custom-next-${data._id}`,
          prevEl: `.custom-prev-${data._id}`,
        }}
        breakpoints={{
          0: { slidesPerView: 2 },
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 5.5 },
        }}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onInit={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
      >
        {products.map((product, index) => {
          const cartItem = getCartItem(product.id); //  IMPORTANT

          return (
            <SwiperSlide key={index}>
              <div className="bg-white border rounded-xl p-3 h-[460px] flex flex-col">
                {/* Discount Badge */}
                {Number(product.discount) > 0 && (
                  <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
                    {product.discount}
                  </div>
                )}


                {/* Image */}
                <div className="p-3 mb-3 rounded-lg bg-gray-50">
                  <img
                    src={product.images?.[0] || "https://placehold.co/300"}
                    alt={product.name}
                    className="object-contain w-full h-40"
                  />
                </div>
                {/* <div className="absolute left-0 z-10 px-3 py-1 text-xs font-bold text-white bg-green-700 rounded-r-full top-2">
    {product.discount}
  </div> */}

                <div
                  className="
    hidden md:inline-flex
    absolute bottom-[220px] right-2
    items-center gap-1
    px-2
    rounded-full
    bg-[#FFF4D6]
    text-[#8A6A00]
    text-sm font-semibold
    whitespace-nowrap
  "
                >
                  <FaClock size={14} />
                  <span>{product.delivery}</span>
                </div>


                {/* Brand */}
                <p className="mt-6 mb-1 text-sm text-gray-500">fresho!</p>

                {/* Product Name */}
                <h3 className="mb-2 text-sm font-medium leading-snug line-clamp-2">
                  {product.name}
                </h3>

                {/* Size Dropdown */}
                {product.size && product.size.length > 0 && (
                  <select
                    className="px-2 py-1 mb-2 text-sm text-black bg-white border rounded-md"
                    value={selectedSizes[product.id]?.sizeIndex ?? ""}

                    onChange={(e) => {
                      const index = Number(e.target.value);

                      const sizeObj = product.size[index];
                      const priceObj = product.get_price_lists[index];


                      setSelectedSizes((prev) => ({
                        ...prev,
                        [product.id]: {
                          sizeIndex: index,
                          sizeId: sizeObj.size_auto_id, // real ID (for cart)
                          sizeName: sizeObj.size_name,
                          price: Number(priceObj?.final_size_price || product.price),
                          stock: Number(sizeObj.size_stock),

                        },
                      }));
                    }}


                  >
                    <option value="" disabled>
                      Select size
                    </option>

                    {product.size.map((s, index) => (
                      <option
                        key={s.size_auto_id}
                        value={index}
                        disabled={Number(s.size_stock) <= 0}
                      >
                        {s.size_name}
                      </option>
                    ))}
                  </select>
                )}

                {/* Price */}
                <div className="mb-2">
                  <p className="text-sm font-semibold text-black">
                    ₹{selectedSizes[product.id]?.price ?? product.price}

                    {product.originalPrice && (
                      <span className="ml-2 text-gray-400 line-through">
                        ₹{product.originalPrice}
                      </span>
                    )}
                  </p>
                </div>






                {/* Bottom Actions */}
                <div className="flex items-center gap-2 mt-auto">
                  <button
                    onClick={(e) => handleWishlistToggle(e, product)}
                    className="p-1 rounded-full"
                  >
                    {wishlisted[product.id] ? (
                      <FaHeart className="w-5 h-5 text-red-500 transition-colors duration-200" />
                    ) : (
                      <FiHeart className="w-5 h-5 text-gray-500 transition-colors duration-200" />
                    )}
                  </button>


                  {/* ADD OR QUANTITY BUTTON */}
                  {!cartItem ? (
                    <button
                      className="flex-1 py-2 font-semibold text-red-500 border border-red-500 rounded-md"
                      onClick={async () => {
                        if (!isLoggedIn()) {
                          setShowLoginMsg((prev) => ({
                            ...prev,
                            [product.id]: true,
                          }));
                          return;
                        }

                        //  size validation
                        if (product.size.length > 0 && !selectedSizes[product.id]?.sizeId) {
                          setMessage((prev) => ({
                            ...prev,
                            [product.id]: "Please select a size",
                          }));

                          setTimeout(() => {
                            setMessage((prev) => {
                              const updated = { ...prev };
                              delete updated[product.id];
                              return updated;
                            });
                          }, 2000);

                          return;
                        }

                        const selected = selectedSizes[product.id];

                        //  ADD TO CART WITH quantity = 1
                        const res = await addToCart({
                          product_auto_id: product.id,
                          added_by_id: product.user_auto_id,
                          cart_quantity: 1,
                          ...(selected?.sizeId && {
                            size: selected.sizeId,
                            size_price: selected.price,
                          }),
                        });

                        // INSTANT UI UPDATE (NO REFRESH)
                        if (res?.status === "1") {
                          setCartData((prev) => [
                            ...prev,
                            {
                              product_auto_id: product.id,
                              cart_product_auto_id: Date.now(), // temp id
                              cart_quantity: 1,
                              size: selected?.sizeId || null,
                            },
                          ]);
                        }
                      }}
                    >
                      Add
                    </button>


                  ) : (

                    <div className="flex items-center justify-between flex-1 px-2 py-1 border rounded-md">
                      <div className="flex items-center justify-center w-full gap-2">
                        {/* MINUS */}
                        <button
                          className="px-2 py-1 border rounded"
                          onClick={() => {
                            // CASE 1: qty = 1 → REMOVE ITEM
                            if (Number(cartItem.cart_quantity) === 1) {
                              //  instant UI update
                              setCartData((prev) =>
                                prev.filter(
                                  (item) =>
                                    item.cart_product_auto_id !==
                                    cartItem.cart_product_auto_id
                                )
                              );

                              //  backend delete
                              removeFromCart(product.id);
                              return;
                            }

                            // CASE 2: qty > 1 → DECREASE
                            const newQty = Number(cartItem.cart_quantity) - 1;

                            // instant UI update
                            setCartData((prev) =>
                              prev.map((item) =>
                                item.cart_product_auto_id === cartItem.cart_product_auto_id
                                  ? { ...item, cart_quantity: newQty }
                                  : item
                              )
                            );

                            // backend sync
                            editCartProduct({
                              cart_product_auto_id: cartItem.cart_product_auto_id,
                              cart_quantity: newQty,
                              size: cartItem.size,
                            });
                          }}
                        >
                          <FaMinus />
                        </button>




                        {/* QUANTITY */}
                        <span className="w-6 font-semibold text-center">
                          {cartItem.cart_quantity}
                        </span>


                        {/* PLUS */}
                        <button
                          className="px-2 py-1 border rounded"
                          onClick={() => {
                            const newQty = Number(cartItem.cart_quantity) + 1;

                            //  instant UI update
                            setCartData((prev) =>
                              prev.map((item) =>
                                item.cart_product_auto_id === cartItem.cart_product_auto_id
                                  ? { ...item, cart_quantity: newQty }
                                  : item
                              )
                            );

                            //  backend update
                            editCartProduct({
                              cart_product_auto_id: cartItem.cart_product_auto_id,
                              cart_quantity: newQty,
                              size: cartItem.size,
                            });
                          }}
                        >
                          <FaPlus />
                        </button>




                      </div>
                    </div>
                  )}



                </div>
                {message?.[product.id] && (
                  <p className="mt-1 text-xs text-red-500">
                    {message[product.id]}
                  </p>
                )}


                {showLoginMsg[product.id] && (
                  <p className="mt-1 text-xs text-red-500">
                    Login first
                  </p>
                )}
              </div>
            </SwiperSlide>
          );
        })}


        {/* Navigation Arrows */}
        <div
          className={`custom-prev-${data._id} absolute top-1/2 left-2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg ${isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
          <FaArrowLeft className="text-xl text-gray-700" />
        </div>
        <div
          className={`custom-next-${data._id} absolute top-1/2 right-2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg ${isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
          <FaArrowRight className="text-xl text-gray-700" />
        </div>
      </Swiper>



      <style>{`
        @keyframes slideUpSlow {
          0% {
            transform: translateY(100%);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
        @media (max-width: 768px) {
          .mobile-slide-up {
            animation: slideUpSlow 0.8s ease-out forwards;
          }
        }
      `}</style>
    </div>
  );
};

export default Product6;

